import axiosClient from '../api/AxiosConfig';

export const ROLE = {
  Admin: 'admin',
  Manager: 'manager',
  Recruit: 'recruit',
  Root: 'root',
  Employee: 'employee',
  CSKH: 'cskh',
};

export const AuthService = {
  login: async (username, password) =>
    (
      await axiosClient.post('/login', {
        username,
        password,
      })
    ).data,
  GetMe: async () => (await axiosClient.get('/get-me')).data,
  ChangePassword: async (data) => (await axiosClient.put('/change-password', data)).data,
};
